import type { FaireProductEntity } from "../../entity_types/product";

export const p_qj798kt2mq: FaireProductEntity = {
  token: "p_qj798kt2mq",
  type: "product",
  name: "Let's Eat Fancy Snacks - Invitation / Greeting Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/2879121e80e0d7dab5e2b28627e90b0249a31bbcbeba633087ead661ba15c192.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8517398fb78c1bfffb749f3af1bab7f97972a8ae89b4b26aa50b5b7cc62b699a.jpeg",
    "https://cdn.faire.com/fastly/513cf4483fd0eb6109f5fe120bec9247d608b51e77b325209ba7684afa052b1c.jpeg"
  ],
  priceDollars: 2.75,
  description: "A cheerful, thoughtful greeting card featuring a playful message and variety of snacks!\n\n\nGood to know: \n\n * Blank on the inside \n * A2 (4.25 inches by 5.5 inches) *New size! \n\n * Includes lavender envelope \n * Individually wrapped in a cellophane sleeve or plastic free with card clasp. ",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:00.924Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
